module.exports = __webpack_public_path__ + "img/dribbble.dad4da0f.svg";